import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28414386"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Keine Meldungen gefunden")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-content-center"
}

import { PropType, onMounted, reactive, ref, watch } from 'vue';
import BmsBoardListEntry from './BmsBoardListEntry.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import Skeleton from 'primevue/skeleton';
import messageRepository from '@/api/messageRepository';
import { Message } from '@/models/message.model';
import { UrlParams } from '@vueuse/core';
import Paginator, { PageState } from 'primevue/paginator';


export default /*#__PURE__*/_defineComponent({
  props: {
  params: { type: Object as PropType<UrlParams>, required: true },
  mapExtent: {
    type: Object as PropType<{
      [x: string]: string | string[];
    }>,
    required: false,
  },
},
  emits: ['switchDetailView', 'updateUrlParamsPageId'],
  setup(__props, { emit }) {

const props = __props




const loading = ref(false);
const first = ref<number>();
const messages = ref<Message[]>();
const page = ref<number>(1);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const fields =
  'text,responsible,created,visible,id,marker_uri,thumbnail_sq64,message_type,state_german,address,state,attribute_values,priority';
const messageListQueryParams = reactive<any>({ page, rows, fields, sort: '-id' });

const listTitle = ref('Letzte Meldungen');

function switchDetailView(params: UrlParams): void {
  emit('switchDetailView', params, true);
}
function fetchMessageList(): void {
  loading.value = true;
  messageRepository
    .getMessagesByQueryParams(messageListQueryParams)
    .then(response => {
      rows.value = response.pager.entries_per_page;
      totalRecords.value = response.pager.total_entries;
      messages.value = response.data;
    })
    .finally(() => {
      loading.value = false;
    });
}

function changePage(event: PageState): void {
  page.value = event.page + 1;
  fetchMessageList();
  emit('updateUrlParamsPageId', { pageid: page.value.toString() });
}
const allowedHashParams = ['messageid', 'state', 'text', 'type', 'sort', 'address', 'top', 'left', 'right', 'bottom'];

function isValidHashParam(param: string): boolean {
  return allowedHashParams.some(hash => hash == param || param.match('.*attribute.*'));
}

function addHashesToQueryParams(params: UrlParams): void {
  //delete all custom params
  allowedHashParams.forEach((allowedHashParam: string) => {
    const keepParam = Object.entries(params).some(param => {
      return allowedHashParam == param[0];
    });

    if (messageListQueryParams[allowedHashParam] == undefined || (!keepParam && allowedHashParam !== 'sort')) {
      delete messageListQueryParams[allowedHashParam];
    }
  });
  //add valid params
  Object.entries(params).forEach(param => {
    if (isValidHashParam(param[0]) && param[1]) {
      messageListQueryParams[param[0]] = param[1].toString();
    }
  });
}
function updatePaginator(): void {
  if (props.params.pageid) {
    page.value = +props.params.pageid;
    first.value = (+props.params.pageid - 1) * 10;
  }
}

onMounted((): void => {
  updatePaginator();
  addHashesToQueryParams(props.params);
  fetchMessageList();
});
watch(
  () => props.params,
  (): void => {
    updatePaginator();
    addHashesToQueryParams(props.params);
    fetchMessageList();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WdwDynbox, {
      title: listTitle.value,
      config: { showControls: false },
      minimize: false,
      watermark: true
    }, {
      default: _withCtx(() => [
        (!loading.value && messages.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-6",
                  key: message.id
                }, [
                  _createVNode(BmsBoardListEntry, {
                    message: message,
                    class: "list-entry",
                    onSwitchDetailView: switchDetailView
                  }, null, 8, ["message"])
                ]))
              }), 128))
            ]))
          : (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                    return _createElementVNode("div", {
                      class: "col-md-6",
                      key: n
                    }, [
                      _createVNode(_unref(Skeleton), {
                        height: "150px",
                        class: "list-entry"
                      })
                    ])
                  }), 64))
                ])
              ]))
            : (!loading.value && !messages.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    (!loading.value)
      ? (_openBlock(), _createBlock(_unref(Paginator), {
          key: 0,
          onPage: changePage,
          first: first.value,
          "onUpdate:first": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
          rows: rows.value,
          totalRecords: totalRecords.value,
          template: " PrevPageLink CurrentPageReport NextPageLink ",
          currentPageReportTemplate: "Meldung {first} bis {last} ({totalRecords} insgesamt)"
        }, null, 8, ["first", "rows", "totalRecords"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(Skeleton), {
            height: "37.7px",
            width: "380px"
          })
        ]))
  ]))
}
}

})